import { message } from 'antd';
import { observer } from 'mobx-react-lite';
import {
  type ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { ADMIN_PERMISSIONS } from '@/auth/permissions';
import { Button } from '@/components/ui/button';
import { authStore, brandStore } from '@/stores';
import { inviteAdminStore } from '@/stores/inviteAdminStore';

export const InviteAdminData = observer(
  ({ children }: { children: ReactNode }) => {
    const appId = brandStore.activeBrandAppId;
    const brandId = brandStore.activeBrandId;
    const canRead = authStore.can(ADMIN_PERMISSIONS.invitesRead);
    const [failed, setFailed] = useState(false);
    const requestId = useRef(0);
    const reload = useCallback(async () => {
      const current = ++requestId.current;
      setFailed(false);
      try {
        await inviteAdminStore.load();
      } catch {
        if (current !== requestId.current) return;
        setFailed(true);
        message.error('加载即时邀请码数据失败，请检查服务配置和权限后重试');
      }
    }, []);
    useEffect(() => {
      inviteAdminStore.setScope(appId && brandId ? { appId, brandId } : null);
      if (appId && canRead) void reload();
      return () => {
        requestId.current++;
        inviteAdminStore.setScope(null);
      };
    }, [appId, brandId, canRead, reload]);
    if (!canRead)
      return (
        <p className="text-sm text-muted-foreground">
          没有邀请码数据读取权限。
        </p>
      );
    if (!appId) return <p>请先选择应用。</p>;
    return (
      <div className="space-y-4">
        <Button
          variant="outline"
          disabled={inviteAdminStore.loading}
          onClick={() => {
            void reload();
          }}
        >
          刷新即时邀请码数据
        </Button>
        {failed ? (
          <p role="alert">即时邀请码服务不可用。请检查服务配置和权限后重试。</p>
        ) : inviteAdminStore.loaded ? (
          children
        ) : (
          <output>正在加载…</output>
        )}
      </div>
    );
  },
);
